import React from "react";
import "./NotFound.css";

export default () =>
  <div className="NotFound">
    <h3>Lo sentimos, página no encontrada!</h3>
  </div>;
